/**
 * Site business type enumeration
 * Matches backend SiteBusinessType.java enum
 */
export enum SiteBusinessType {
  CONTENT = 'CONTENT',
  ECOMMERCE = 'ECOMMERCE',
  SAAS = 'SAAS',
  LOCAL_BUSINESS = 'LOCAL_BUSINESS',
  UNKNOWN = 'UNKNOWN'
}

/**
 * Business type metadata stored in JSONB column
 */
export interface BusinessMetadata {
  hasLocalBusinessSchema: boolean;
  hasGoogleBusinessProfileLink: boolean;
  hasNAP: boolean;
  napData?: {
    name?: string;
    address?: string;
    phone?: string;
  };
  detectionConfidence?: number;
  detectionMethod?: string;
}

/**
 * Site entity extension with business type fields
 */
export interface SiteWithBusinessType {
  id: number;
  tenantId: number;
  name: string;
  siteUrl: string;
  businessType: SiteBusinessType;
  businessTypeDetectedAt?: string;
  businessMetadata?: BusinessMetadata;
}

/**
 * Helper functions for business type
 */
export const businessTypeHelpers = {
  getDisplayName(type: SiteBusinessType): string {
    const labels: Record<SiteBusinessType, string> = {
      [SiteBusinessType.CONTENT]: 'Content Site',
      [SiteBusinessType.ECOMMERCE]: 'E-commerce',
      [SiteBusinessType.SAAS]: 'SaaS Platform',
      [SiteBusinessType.LOCAL_BUSINESS]: 'Local Business',
      [SiteBusinessType.UNKNOWN]: 'Unknown',
    };
    return labels[type];
  },

  isLocalBusiness(type: SiteBusinessType): boolean {
    return type === SiteBusinessType.LOCAL_BUSINESS;
  },

  isIdentified(type: SiteBusinessType): boolean {
    return type !== SiteBusinessType.UNKNOWN;
  },

  getIcon(type: SiteBusinessType): string {
    const icons: Record<SiteBusinessType, string> = {
      [SiteBusinessType.CONTENT]: '📝',
      [SiteBusinessType.ECOMMERCE]: '🛒',
      [SiteBusinessType.SAAS]: '💼',
      [SiteBusinessType.LOCAL_BUSINESS]: '📍',
      [SiteBusinessType.UNKNOWN]: '❓',
    };
    return icons[type];
  }
};
